// src/utilis/routeRegistration/helpers.js
// Helpers puros (sem React) usados no RouteRegistration

export const toRad = (v) => (v * Math.PI) / 180;

export const haversineKm = (a, b) => {
  const R = 6371;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);

  const x =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * (Math.sin(dLng / 2) ** 2);

  return 2 * R * Math.asin(Math.min(1, Math.sqrt(x)));
};

export const simplifyPoints = (pts, step = 3) => {
  if (!Array.isArray(pts) || pts.length <= 2) return pts || [];
  const out = [];
  for (let i = 0; i < pts.length; i += step) out.push(pts[i]);
  const last = pts[pts.length - 1];
  const lastOut = out[out.length - 1];
  if (!lastOut || lastOut.lat !== last.lat || lastOut.lng !== last.lng) out.push(last);
  return out;
};

export const buildCumulativeKm = (pts) => {
  const cum = [];
  let acc = 0;
  for (let i = 0; i < pts.length; i++) {
    if (i === 0) {
      cum.push(0);
      continue;
    }
    acc += haversineKm(pts[i - 1], pts[i]);
    cum.push(Number(acc.toFixed(4)));
  }
  return cum;
};

export const decodePolylineToPoints = (polylineObjOrStr) => {
  const encoded =
    typeof polylineObjOrStr === "string"
      ? polylineObjOrStr
      : polylineObjOrStr?.points || "";

  if (!encoded) return [];

  const enc = window.google?.maps?.geometry?.encoding;
  if (!enc?.decodePath) return [];

  const path = enc.decodePath(encoded);
  return path.map((p) => ({ lat: p.lat(), lng: p.lng() }));
};

// Normaliza cidade (remove UF, acento, caixa)
export const normCityKey = (v) => {
  const s = String(v || "").trim().toLowerCase();
  if (!s) return "";
  const base = s.split("-")[0].split(",")[0].trim();
  return base.normalize("NFD").replace(/\p{Diacritic}/gu, "");
};
